module.exports = __webpack_public_path__ + "img/ic_radio_checked.b4b7fd17.svg";